const NPC_ANIMS = [
  { suffix: "idle", end: 11, repeat: -1 },
  { suffix: "idle_blinking", end: 11, repeat: -1 },
  { suffix: "walking", end: 15, repeat: -1 },
  { suffix: "running", end: 7, repeat: -1 },
  { suffix: "hurt", end: 7, repeat: 0 },
  { suffix: "dying", end: 9, repeat: 0 },
];

export const NPC_TYPES = {
  blacksmith_guy: {
    prefix: "blacksmith_guy",
    dir: "assets/characters/Blacksmith_Guy_spritesheets/",
    originX: 0.5,
    originY: 0.8519,
    w: 30,
    h: 50,
    anims: NPC_ANIMS,
    speed: 0.38,
    patrolDistance: 170,
  },
  black_ninja: {
    prefix: "black_ninja",
    dir: "assets/characters/Black_Ninja_spritesheets/",
    originX: 0.4933,
    originY: 0.8321,
    w: 30,
    h: 50,
    anims: NPC_ANIMS,
    speed: 0.44,
    patrolDistance: 180,
  },
  archer_guy: {
    prefix: "archer_guy",
    dir: "assets/characters/Archer_Guy_spritesheets/",
    originX: 0.5593,
    originY: 0.8582,
    w: 30,
    h: 50,
    anims: NPC_ANIMS,
    speed: 0.42,
    patrolDistance: 180,
  },
  medieval_mage: {
    prefix: "medieval_mage",
    dir: "assets/characters/Medieval_Mage_spritesheets/",
    originX: 0.5316,
    originY: 0.7987,
    w: 30,
    h: 50,
    anims: NPC_ANIMS,
    speed: 0.4,
    patrolDistance: 170,
  },
  white_ninja: {
    prefix: "white_ninja",
    dir: "assets/characters/White_Ninja_spritesheets/",
    originX: 0.4967,
    originY: 0.8478,
    w: 30,
    h: 50,
    anims: NPC_ANIMS,
    speed: 0.44,
    patrolDistance: 180,
  },
  magician_2: {
    prefix: "magician_2",
    dir: "assets/characters/Magician_2_spritesheets/",
    originX: 0.4968,
    originY: 0.8741,
    w: 30,
    h: 50,
    anims: NPC_ANIMS,
    speed: 0.39,
    patrolDistance: 170,
  },
};

const NPC_TYPE_ALIASES = {
  archer_1: "black_ninja",
};

export function resolveNpcTypeDef(npcTypeRaw) {
  const key = String(npcTypeRaw || "").trim().toLowerCase();
  if (!key) return NPC_TYPES.black_ninja;
  const resolvedKey = NPC_TYPE_ALIASES[key] || key;
  return NPC_TYPES[resolvedKey] || NPC_TYPES.black_ninja;
}
